<script>
import getSecret from '@utils/get-secret'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import BaseDatatable from '@components/base-datatable'
import { euroCouponsThirdpartyMethods, euroCouponsTutorialMethods } from '@state/helpers'

export default {
  name: 'EuroCouponsThirdpartyIndex',
  page: {
    title: 'Thirdparty',
    meta: [{ name: 'description', content: getSecret('DESCRIPTION') }],
  },
  components: { 
    Layout, PageHeader, BaseDatatable, 
    EuroCouponsThirdpartyModal: () => import('@components/euro_coupons/thirdparty/Modal'), 
    EuroCouponsThirdpartyDetail: () => import('@components/euro_coupons/thirdparty/Detail'),
    EuroCouponsThirdpartyDelete: () => import('@components/euro_coupons/thirdparty/Delete')
  },
  data() {
    return {
      title: this.$t('thirdparties'),
      items: [
        {
          text: this.$t('home'),
          href: '/',
        },
        {
          text: this.$t('thirdparties'),
          active: true,
        },
      ],
      tableHeaders: [],
      toUpdate : {},
      toDetail : {},
      toDelete: {},
      showForm: false,
      showDetail: false,
      showDelete: false,
    }
  },

  mounted() {
    this.setShowTutorial(true)
    this.setTutorialUrl('aliados')
  },

  destroyed() {
    this.setShowTutorial(false)
  },

  beforeMount(){
    this.tableHeaders = [
        // { key: 'logo', label: this.$t('logo') },
        { key: 'name', label: this.$t('thirdparty') },
        // { key: 'nit', label: this.$t('nit') },
        { key: 'payment_due_date', label: this.$t('payment_due_date') },
        { key: 'contact_name', label: this.$t('contact') },
        // { key: 'contact_email', label: this.$t('contact_email') },
        { key: 'prefix_code', label: this.$t('prefix_code') },
        { key: 'actions', label: this.$t('actions') },
    ]
  },

  methods: {
    ...euroCouponsThirdpartyMethods,
    ...euroCouponsTutorialMethods,

    myProvider(ctx) {
      let context = this
      const promise = context.fetchEuroCouponsThirdparty(context.$table_params(ctx))
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          console.log(error)
          return []
        })
    },

  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container fluid class="p-0 shadow">
      <b-row>
        <b-col>
          <b-card>
            <!-- <b-button
              variant="primary"
              size="sm"
              @click="()=>{showForm=true; toUpdate={}}"
            >
              <i class="fe-plus"></i> {{ $t('create') }}
            </b-button> -->

            <BaseDatatable
              ref="thirdparty_table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
            >
            <template v-slot:buttons>
                <b-button
              variant="outline-primary rounded-lg pt-1"
              size="sm"
              @click="()=>{showForm=true; toUpdate={}}"
            >
              <!-- <i class="fe-plus" style="font-size:18px"></i> -->
              <i class="fas fa-plus"></i>
            </b-button>
              </template>

              <template v-slot:cell(name)="row">
                <b-row>
                  <b-col cols="4" class="pr-0">
                    <b-avatar size="54px" class="border border-primary " :src="row.item.logo || require('@assets/images/users/avatar-clear.png')"></b-avatar>
                  </b-col>
                  <b-col class="d-flex flex-column justify-content-center">
                    <p class="p-0 m-0 font-weight-bold">{{row.item.name}}</p>
                    <i class="p-0 m-0">NIT {{row.item.nit}}</i>
                  </b-col>
                </b-row>
                
              </template>
              <template v-slot:cell(contact_name)="row">
                <b-row>
                  <b-col class="d-flex flex-column justify-content-center">
                    <p class="p-0 m-0"> {{row.item.contact_name}}</p>
                    <p class="p-0 m-0 font-weight-bold"> </p>
                    <i class="p-0 m-0">{{row.item.contact_email}}</i>
                  </b-col>
                </b-row>
                
              </template>

              <template v-slot:cell(actions)="row">
                <b-button-group size="xs">
                  <!-- <b-button
                    :id="`info-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'info',
                      placement: 'leftbottom',
                      title: $t('detail'),
                    }"
                    variant="btn-link text-info btn-transparent"
                    size="xs"
                    @click="()=>{showDetail=true; toDetail=row.item}"
                  >
                    <i
                      class="fe-info fe-2x"
                    ></i>
                  </b-button> -->

                  <b-button
                    :id="`update-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'warning',
                      placement: 'leftbottom',
                      title: $t('edit'),
                    }"
                    variant="btn-link text-warning btn-transparent"
                    size="xs"
                    @click="()=>{showForm=true; toUpdate=row.item}"
                  >
                    <i class="fe-edit fe-2x"></i>
                  </b-button>

                  <b-button
                    :id="`delete-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'danger',
                      placement: 'leftbottom',
                      title: $t('delete'),
                    }"
                    variant="btn-link text-danger btn-transparent"
                    size="xs"
                    @click="()=>{showDelete=true; toDelete=row.item}"
                  >
                    <i class="fe-x fe-2x"></i>
                  </b-button>
                </b-button-group>
              </template>
            </BaseDatatable>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <!-- Detail modal -->
    <!-- <EuroCouponsThirdpartyDetail
      v-if="showDetail"
      :instanceJson="toDetail || {}"
      :oncomplete="
        () => {
          showDetail = false;
          toDetail = {};
        }
      "
      :oncancel="
        () => {
          showDetail = false;
          toDetail = {}
        }
      "
    >
    </EuroCouponsThirdpartyDetail> -->

    <EuroCouponsThirdpartyModal
      v-if="showForm"
      :fullform="true"
      :instanceJson="toUpdate || {}"
      :oncomplete="
        () => {
          showForm = false;
          toUpdate = {};
          $refs.thirdparty_table.refresh()
        }
      "
      :onclose="
        () => {
          showForm = false;
          toUpdate = {}
          $refs.thirdparty_table.refresh()

          
        }
      "
    >
    </EuroCouponsThirdpartyModal>

    <EuroCouponsThirdpartyDelete
      v-if="showDelete"
      :instanceJson="toDelete"
      :oncomplete="
        () => {
          showDelete = false;
          toDelete = {};
          $refs.thirdparty_table.refresh()
        }
      "
      :oncancel="
        () => {
          showDelete = false;
          toDelete = {}
        }
      "
    >
    </EuroCouponsThirdpartyDelete>
  </Layout>
</template>
